import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import links from '@app/constants/links';
import { replaceTokensInUrl } from '@app/utils';
export const AddToCartToast = () => {
  const [t] = useTranslation();
  const { storeId, catalogId, langId } = useSelector(state => state.common);
  const { SHOPPING_CART_LINK } = links;
  const cartUrl = replaceTokensInUrl(
    SHOPPING_CART_LINK,
    storeId,
    langId,
    catalogId
  );
  return (
    <div>
      <p>{t('2483_PDP_ADD_TO_CART_MULTIPLE_MODAL')}</p>
      <div className="text-start my-1">
        <a className="btn btn-primary btn-sm w-100 w-lg-auto" href={cartUrl}>
          {t('MSC_GO_TO_CART')}
        </a>
      </div>
    </div>
  );
};
